import React, { FC } from 'react';

import { ListItemGroup } from 'components/list-item-group';

import { Modifier } from '../modifier';

import { IModifierGroupProps } from './types';

export const ModifierGroup: FC<IModifierGroupProps> = ({
  displayGroupName,
  modifiers,
  onModifierSelectionChange,
  selectedItem,
}) => {
  return (
    <ListItemGroup
      header={displayGroupName}
      items={modifiers.map(modifierProps => (
        <Modifier
          key={`modifier-${modifierProps.modifier.name?.locale}`}
          {...modifierProps}
          onSelectionsChange={selections =>
            onModifierSelectionChange(selections, modifierProps.modifier)
          }
          selectedItem={selectedItem}
        />
      ))}
      isNested
    />
  );
};
